import { useParams } from "react-router-dom";
import { featuredArticles, portalArticles, hotArticles } from "@/mocks/articles";
import ArticleHeader from "./components/ArticleHeader";
import ArticleBody from "./components/ArticleBody";
import ArticleComments from "./components/ArticleComments";
import RelatedArticles from "./components/RelatedArticles";
import DiscussionCTA from "./components/DiscussionCTA";
import NotFound from "@/pages/NotFound";
import { StructuredData, generateBreadcrumbLD, generateArticleLD } from "@/components/base/StructuredData";

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();

  const allArticles = Array.from(
    new Map(
      [...featuredArticles, ...portalArticles, ...hotArticles].map((article) => [
        article.id,
        article,
      ])
    ).values()
  );
  const article = allArticles.find((a) => a.id === id);

  if (!article) {
    return <NotFound />;
  }

  const breadcrumbLD = generateBreadcrumbLD([
    { name: "首页", url: "http://cgiqwhk.cn/" },
    { name: article.categoryName, url: `http://cgiqwhk.cn/category/${article.category}` },
    { name: article.title, url: `http://cgiqwhk.cn/article/${article.id}` },
  ]);

  const articleLD = generateArticleLD(article);

  return (
    <>
      <StructuredData data={breadcrumbLD} />
      <StructuredData data={articleLD} />
      <ArticleHeader article={article} />
      <ArticleBody article={article} />
      <ArticleComments articleId={article.id} />
      <RelatedArticles currentArticleId={article.id} />
      <DiscussionCTA />
    </>
  );
}
